export interface Address {
  Line1:string;
  Line2:string;
  Line3:string;
  City:string;
  StateProvinceCounty:string;
  ZipOrPostcode:string;
  Country:string;
  Other:string;
}

export interface Box {
  DeviceId:string,
  Name:string,
  LocationId:string,
  Connected:boolean,
  Ssid:string,
  IpAddress:string

  EmgMac:string,
  EmgFirmware: string,
  EmgNotchFreq: number,
  EmgMode: number,
  RomMac:string,
  ThermalMac:string,
  ThermalSyncLeft: number,
  ThermalSyncRight: number,
  ThermalV2:boolean,
  HrvMac:string,
  HrvFirmware: string,
  AlgoMac:string,

  Emg:boolean,
  Thermal:boolean,
  Hrv:boolean,
  Rom:boolean,
  Algo:boolean,

  Region: string,
  SslFallback:boolean

  CurrentVersion:string;
  UpdateAvailable:boolean;
  UpdateVersionAvailable:string;
  SyncActiveState:boolean;
}

export enum EmgFreqType
{
  "60Hz"= 2,
  "50Hz" = 1,
}

export enum EmgMode
{
  // These corrolate to the display mode on the EMG device itself
  "Standard"= 0 ,
  "Enhanced"= 2
}

export class ProgramStep {
  Location: SpinalLocation;
  Dual: boolean;
  get LeftComplete(): boolean {
    return this.LeftValue > 0;
  }
  get RightComplete(): boolean {
    return this.RightValue > 0;
  }
  LeftValue: number;
  RightValue: number;
}

export class ThermalProgramStep extends ProgramStep {
  LeftIr: number;
  LeftTherm: number;

  get LeftComplete(): boolean {
    return this.LeftTherm > 0;
  }
}

export interface ApiVersion {
  version: string;
}
export interface KeyPerformanceIndicators {
  AverageInitialChildCoreScore: number,
  AverageInitialAdultCoreScore: number,
  InitialChildCoreScoreScans: number,
  InitialAdultCoreScoreScans: number,
  AverageProgressChildCoreScore: number,
  AverageProgressAdultCoreScore: number,
  ProgressChildCoreScoreScans: number,
  ProgressAdultCoreScoreScans: number,
  AverageComparativeChildCoreScore: number,
  AverageComparativeAdultCoreScore: number,
  ComparativeChildCoreScoreScans: number,
  ComparativeAdultCoreScoreScans: number,
  AverageContinuationChildCoreScore: number,
  AverageContinuationAdultCoreScore: number,
  ContinuationChildCoreScoreScans: number,
  ContinuationAdultCoreScoreScans: number,
  AverageHrvChildScore: number,
  AverageHrvAdultScore: number,
  HrvChildScans: number,
  HrvAdultScans: number,
  AverageThermalChildScore: number,
  AverageThermalAdultScore: number,
  ThermalChildScans: number,
  ThermalAdultScans: number,
  AverageEmgChildScore: number,
  AverageEmgAdultScore: number,
  EmgChildScans: number
  EmgAdultScans: number
}
export enum Techniques {
  Unspecified = 1,
  Gonstead = 2,
  Activator = 4,
  Flexion = 8,
  Thompson = 16,
  Diversified = 32,
  Webster = 64,
}
export enum ReportLanguage {
  English = 0,
  French = 1,
  German = 2,
  Spanish = 3,
  Norwegian = 4,
  Italian = 5,
  Dutch = 6,
  Portuguese = 7,
}
export interface Log {
  fileName: string,
  contents: string
}

export interface ProtocalLocation {
  Location: SpinalLocation,
  Dual: boolean,
  LeftValue: number,
}

export function newBox(): Box {
  return {
    DeviceId: '',
    Connected: false,
    Name: '',
    LocationId: '',
    Ssid: '',
    IpAddress: '',
    EmgMac: '',
    EmgFirmware: '',
    RomMac: '',
    ThermalMac: '',
    HrvMac: '',
    HrvFirmware: '',
    AlgoMac: '',
    Emg: false,
    Thermal: false,
    Hrv: false,
    Rom: false,
    Algo: false,
    SslFallback: false,
    CurrentVersion: '',
    UpdateAvailable: false,
    UpdateVersionAvailable: '',
    SyncActiveState: false,
    EmgNotchFreq: 2,
    EmgMode: 0,
    Region: 'Dev',
    ThermalSyncLeft: 1,
    ThermalSyncRight: 1,
    ThermalV2: false
  }
}
export enum Gender {
  Male,
  Female,
  Other,
  Nonbinary

}

export enum AlgoScanSteps {
  Preparing,
  Calibrating,
  SelectRegion,
  Baseline,
  Comparative,
  Complete
}

export enum ScanTypes {
  EMG,
  HRV,
  Thermal,
  ROM,
  Algo,
  RollingThermal
}

export enum RomTestTypes {
  CervicalFlexionExtension,
  CervicalLateralFlexion,
  CervicalRotation,
  ThoracicKyphosis,
  ThoracicRotation,
  LumbosacralFlexionExtension,
  LumbosacralLateralFlexion
}

export enum RomResultTypes {
  Flexion,
  Extension,
  LeftLateralBending,
  RightLateralBending,
  LeftRotation,
  RightRotation,
  Kyphosis
}



export enum ScanProtocolContexts {
  None = 0x0,
  Thermal = 0x1,
  EMG = 0x2,
  Normal = 0x4,
  Comparative = 0x8
}

export enum ScanProtocolOptions {
  Skip,
  Bilateral,
  Unilateral
}

export enum ScanPosition {
  Standing,
  Seated
}

export enum EmgSpinalLocation {
  C1 = 0,
  C3 = 2,
  C5 = 4,
  C7 = 6,
  T1 = 7,
  T2 = 8,
  T4 = 10,
  T6 = 12,
  T8 = 14,
  T10 = 16,
  T12 = 18,
  L1 = 19,
  L3 = 21,
  L5 = 23,
  S1 = 24
}

// 28 Total
export enum SpinalLocation {
  C1,
  C2, //1
  C3, //2
  C4,
  C5,
  C6,
  C7,
  T1, //7
  T2,
  T3,
  T4,
  T5,
  T6,
  T7,
  T8,
  T9,
  T10,
  T11,
  T12,
  L1, //19
  L2,
  L3,
  L4,
  L5,
  S1, // 24
  S2,
  S3,
  S4,
  S5,
  C1L,
  C1R
}

export enum ValidSpinalLocation {
  C3 = 2, //2
  C4,
  C5,
  C6,
  C7,
  T1, //7
  T2,
  T3,
  T4,
  T5,
  T6,
  T7,
  T8,
  T9,
  T10,
  T11,
  T12,
  L1, //19
  L2,
  L3,
  L4,
  L5,
  S1, // 24
}

export enum ScanState {
  Initial,
  Options,
  Calibration,
  Scanning,
  Complete
}

export class WifiInfo {
  static readonly SSID: string = 'INSiGHTBridge';
}
 export interface EMGConfig {
  rmsNotchFilter: number;
}



// WEBPACK FOOTER //
// ./src/model/weak-entities.ts